import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

interface BackButtonProps {
  goTo: string;
}

const BackButton : React.FC<BackButtonProps> = ({ goTo }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();


  return (
    <button type="button" className="btn btn-secondary" onClick={() => navigate(goTo)}>
      {t('Back')}
    </button>
  );
};

export default BackButton;
